import IParametricTableRepo from "@/repositories/parametricTables/IParametricTableRepo";
import ParametricTableRepoFirebase from "@/repositories/parametricTables/ParametricTableRepoFirebase";

class ParametricTableService {
    private static instance: ParametricTableService;
    private repo: IParametricTableRepo;
    private tables: Map<string, Object>;

    private constructor(){
        //console.log("ParametricTableService constructor")
        this.repo = new ParametricTableRepoFirebase() as unknown as IParametricTableRepo
        this.tables = new Map<string, Object>()
    }

    public static getInstance(): ParametricTableService {
        if (!ParametricTableService.instance) {
            ParametricTableService.instance = new ParametricTableService();
        }

        return ParametricTableService.instance;
    }

    /*public getParametricTable(ref: string): Object | undefined {
        if(!this.tables.has(ref) && this.repo) {
            console.log("ParametricTableService - Vamos al repo a buscar el tipo", ref)
            this.repo.getParametricTable(ref, this.foundTypeCallback)
        } else {
            console.log("No encuentro la referencia: " + ref)
            return this.foundTypeCallback(ref, this.tables.get(ref)!)
        }
    }*/

    public getParametricTable(ref: string): Object {
        if(!this.tables.has(ref) && this.repo) {
            //console.log("ParametricTableService - Vamos al repo a buscar el tipo", ref)
            return this.repo.getParametricTable(ref, this.foundTypeCallback)
        } else {
            //console.log("No encuentro la referencia: " + ref)
            return this.foundTypeCallback(ref, this.tables.get(ref)!)
        }
    }

    public foundTypeCallback(ref: string, table: Object){
        ParametricTableService.getInstance().tables.set(ref, table)
        return table
    }
}

export default ParametricTableService;